/* eslint-disable */
export default {
  feedbackHeader: 'Envoyer le commentaire',
  back: 'Revenir',
  revert: 'Rétablir',
  instruction:
    'Vos commentaires sont très importants pour nous. Si vous rencontrez des difficultés pendant votre utilisation de l’application, si vous souhaitez faire la demande d’une fonctionnalité ou signaler un bogue, nous sommes toujours heureux de vous aider.',
  fillForm: 'Veuillez remplir le formulaire ci-dessous et cliquer sur ',
  useMailBox:
    ' ou veuillez utiliser votre messagerie pour envoyer votre requête à ',
  email: 'Votre adresse courriel',
  reply: '(pour que nous puissions vous répondre)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Sujet des commentaires',
  topicPlaceHolder: 'Veuillez choisir une option',
  bugReport: 'Signalement de bogue',
  featureRequest: 'Demande de fonctionnalité',
  others: 'Autres',
  subject: 'Objet',
  subjectPlaceHolder: 'Veuillez nous indiquer comment nous pouvons vous aider',
  description: 'Description complète',
  descriptionPlaceHolder: 'Veuillez écrire le plus d’informations possible',
  send: 'Envoyer vos commentaires',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
